/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {SelectItem} from 'primeng/api';

export class OpportunityListMeta extends JSONable {
  totalSize: number | undefined = undefined;
  totalPotentialGPSum: number | undefined = undefined;
  totalPotentialRevenueSum: number | undefined = undefined;
  shipmentPotentialGPSum: number | undefined = undefined;
  numberOfShipmentsSum: number | undefined = undefined;
  shipmentRevenueSum: number | undefined = undefined;
  pipelineStageOptions: string[] | undefined = undefined;
  opportunityTypeOptions: string[] | undefined = undefined;
  contractSigned: SelectItem[] | undefined = undefined;
  opportunityType: SelectItem[] | undefined = undefined;
  pipelineStage: SelectItem[] | undefined = undefined;
  reasonWonLost: any[] | undefined = undefined;

  constructor() {
    super();
    this.totalSize = 0;
    this.totalPotentialGPSum = 0;
    this.totalPotentialRevenueSum = 0;
    this.shipmentPotentialGPSum = 0;
    this.numberOfShipmentsSum = 0;
    this.shipmentRevenueSum = 0;
    this.opportunityTypeOptions = [];
    this.pipelineStageOptions = [];
    this.reasonWonLost = [];
  }
}
